import React from 'react';

export const createFormPageTitle = title => (
  <h3 className="vads-u-margin--0">{title}</h3>
);
